import SearchIcon from "assets/icons/SearchIcon";
import { t } from "i18next";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSearchMajor } from "store/api/LifeChoiceBlocks";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";

export default function SearchBox() {
  const { dir, language } = useAppSelector(getSettings);
  const [searchText, setSearchText] = useState("");
  const { data, isLoading } = useSearchMajor({
    searchTerm: searchText,
  });
  const navigate = useNavigate();

  return (
    <div
      className="border-2 border-theme-gray flex gap-2 items-center px-3 py-1 rounded-md relative focus-within:border-theme-blue"
      dir={dir}
    >
      <div
        className="cursor-pointer"
        onClick={() => {
          document.getElementById("header-searchbox").focus();
        }}
      >
        <SearchIcon fill="#F29423" size={15} />
      </div>
      <input
        type="text"
        className="w-full focus-within:outline focus-visible:outline-none"
        placeholder={t('searchFieldPlaceholder')}
        id="header-searchbox"
        value={searchText}
        onChange={(e) => {
          setSearchText(e.target.value);
        }}
      />
      {searchText && (
        <div
          className="absolute w-full shadow-md top-[calc(100%+8px)] left-0 py-3 bg-white z-10 max-h-96 h-fit overflow-y-auto"
          dir={dir}
        >
          {isLoading ? (
            <div>Loading...</div>
          ) : data?.length === 0 ? (
            <div className="px-3 py-2 " dir={dir}>
              {t("noResultsFound")}
            </div>
          ) : (
            data?.map((ele) => (
              <div
                key={ele.id}
                className="px-3 py-2 cursor-pointer hover:bg-gray-100"
                onClick={() => {
                  setSearchText(ele.title[language]);
                  navigate(`/${ele._id}`);
                }}
                dir={dir}
              >
                {ele.title[language]}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}
